import axios from "axios";
import { CONST } from "../config/const";

// 外部ETフォーム取得
export async function getSiteLayout(
  inputID: string,
  display: string,
  pathName: string
) {
  try {
    const path = "siteLayout";
    const params = { inputID, display, pathName };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const layout_data = response.data.layout_data[0] as {
      site_color: string;
      site_layout: string;
      site_title: string;
      site_footer: string;
      service_page_url: string;
    };
    const header_location_favicon = response.data
      .header_location_favicon as string;
    const header_location_logo = response.data.header_location_logo as string;
    const pdf_datas = response.data.pdf_datas as {
      header_location_pdf: string;
      site_pdf_name: string;
      site_pdf_agree: string;
      site_pdf_footer: string;
    }[];
    const trial_period_months = response.data.trial_period_months as string;
    const service_option_name_pull_down = response.data
      .service_option_name_pull_down as string;
    const service_option_name_check_box = response.data
      .service_option_name_check_box as string;
    const service_required_optional_pull_down = response.data
      .service_required_optional_pull_down as string;
    const service_required_optional_check_box = response.data
      .service_required_optional_check_box as string;
    const payment_method = response.data.payment_method as {
      type: "j-payment" | "sbpayment-softbank" | "sbpayment-kddi";
      name: string;
    }[];
    const pull_down_service = response.data.pull_down_service as {
      id: number;
      service_name: string;
      value: number;
      tax: number;
    }[];
    const check_box_service = response.data.check_box_service as {
      id: number;
      service_name: string;
      value: number;
      tax: number;
    }[];
    const options = response.data.options as {
      option_name: string;
      required_optional: number;
      option_type: number;
      option_comment: string;
      option_default_value: string;
      change_value_conf: number;
      tel_flg: number;
      name_flg: number;
      company_name_flg: number;
      zip_code_flg: number;
      address_flg: number;
      space_flg: number;
      mail_address_flg: number;
      form_tel_flg: number;
      multi_text_flg: number;
      half_width_number_flg: number;
      option_select: string[];
      depend_service_names: string[];
      depend_option_name: string;
      depend_select_names: string[];
    }[];
    const input_customer_info = response.data.input_customer_info[0] as {
      [key: string]:
        | string
        | {
            [key: string]: string;
          };
    };
    return {
      layout_data,
      header_location_favicon,
      header_location_logo,
      pdf_datas,
      trial_period_months,
      service_option_name_pull_down,
      service_option_name_check_box,
      service_required_optional_pull_down,
      service_required_optional_check_box,
      payment_method,
      pull_down_service,
      check_box_service,
      options,
      input_customer_info,
    };
  } catch (error) {
    // logout();
    return {
      layout_data: {
        site_color: "",
        site_layout: "",
        site_title: "",
        site_footer: "",
        service_page_url: "",
      },
      header_location_favicon: "",
      header_location_logo: "",
      pdf_datas: [],
      trial_period_months: "",
      service_option_name_pull_down: "",
      service_option_name_check_box: "",
      service_required_optional_pull_down: "",
      service_required_optional_check_box: "",
      payment_method: [],
      pull_down_service: [],
      check_box_service: [],
      options: [],
      input_customer_info: {},
    };
  }
}

// 解約用レイアウト取得
export async function getCancellSiteLayout(display: string, pathName: string) {
  try {
    const path = "cancellSiteLayout";
    const params = { display, pathName };
    const response = await axios.get(CONST.cancellApiUrl + path, {
      params,
    });
    const layout_data = response.data.layout_data[0] as {
      site_color: string;
      site_layout: string;
      site_title: string;
      site_footer: string;
      service_page_url: string;
      header_location_logo: string;
      outside_cancell_form_text: string;
      outside_cancell_form_mail_address: string;
    };
    const header_location_favicon = response.data
      .header_location_favicon as string;
    const header_location_logo = response.data.header_location_logo as string;
    const pdf_datas = response.data.pdf_datas as {
      header_location_pdf: string;
      site_pdf_name: string;
      site_pdf_agree: string;
      site_pdf_footer: string;
    }[];
    return {
      layout_data,
      header_location_favicon,
      header_location_logo,
      pdf_datas,
    };
  } catch (error) {
    // logout();
    return {
      layout_data: {
        site_color: "",
        site_layout: "",
        site_title: "",
        site_footer: "",
        service_page_url: "",
        outside_cancell_form_text: "",
        outside_cancell_form_mail_address: "",
      },
      header_location_favicon: "",
      header_location_logo: "",
      pdf_datas: [],
    };
  }
}
